export default {"src":"/_next/static/media/appStore.38534858.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};